import { render, staticRenderFns } from "./DxMachineryPerformance.vue?vue&type=template&id=6cfefb81&"
import script from "./DxMachineryPerformance.vue?vue&type=script&lang=js&"
export * from "./DxMachineryPerformance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports